export default __webpack_public_path__ + "4ad7c7e8bb8d10a34bb7c4bb567cef92.ttf";